(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wim-gy-whatsapp-modal"] && !Shopify.designMode) return;
  try {
    
(() => {
  const key = 'wim-gy-wa-dismissed-v1';
  function init(root) {
    root.querySelectorAll('[data-wim-gy-wa]').forEach(dialog => {
      if (dialog.dataset.ready || typeof dialog.showModal !== 'function') return;
      dialog.dataset.ready = 'true';
      const dismissed = () => { try { return Date.now() - Number(localStorage.getItem(key) || 0) < 604800000; } catch (_) { return false; } };
      const remember = () => { try { localStorage.setItem(key, String(Date.now())); } catch (_) {} };
      dialog.querySelectorAll('[data-wim-wa-close]').forEach(button => button.addEventListener('click', () => dialog.close()));
      dialog.addEventListener('close', remember);
      dialog.addEventListener('click', event => { if (event.target === dialog) { const rect = dialog.getBoundingClientRect(); if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close(); } });
      if (!dismissed()) window.setTimeout(() => { if (dialog.isConnected && !dialog.open) dialog.showModal(); }, 1800);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once:true }); else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wim-seasonal-hero"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('wim-seasonal-hero')){
  customElements.define('wim-seasonal-hero',class extends HTMLElement{
    connectedCallback(){
      this.track=this.querySelector('.wim-seasonal__track');
      this.slides=Array.from(this.querySelectorAll('.wim-seasonal__slide'));
      this.index=0;this.paused=matchMedia('(prefers-reduced-motion: reduce)').matches;
      if(this.classList.contains('wim-seasonal--asian')){
        const target=document.querySelector('.wim-asian__result-head h2');
        if(target&&target.id)this.querySelector('a').setAttribute('href','#'+target.id);
      }
      if(this.slides.length<2)return;
      this.pauseButton=this.querySelector('[data-pause]');
      this.paintPause();
      this.querySelectorAll('[data-step]').forEach(button=>button.addEventListener('click',()=>{this.paused=true;this.paintPause();this.move(Number(button.dataset.step));}));
      this.pauseButton.addEventListener('click',()=>{this.paused=!this.paused;this.paintPause();});
      this.track.addEventListener('scroll',()=>{this.index=Math.round(this.track.scrollLeft/this.track.clientWidth);this.querySelector('[data-position]').textContent=(this.index+1)+' / '+this.slides.length;},{passive:true});
      this.timer=setInterval(()=>{if(!this.paused&&!this.matches(':hover')&&!this.contains(document.activeElement)&&!document.hidden)this.move(1);},7000);
    }
    paintPause(){this.pauseButton.textContent=this.paused?this.pauseButton.dataset.playLabel:this.pauseButton.dataset.pauseLabel;}
    move(step){this.index=(this.index+step+this.slides.length)%this.slides.length;this.track.scrollTo({left:this.index*this.track.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});}
    disconnectedCallback(){clearInterval(this.timer);}
  });
}

  } catch(e) { console.error(e); }
})();
})();
